export default __webpack_public_path__ + "static/media/Background4.441b39c5.png";